<template>
  <div class="detail flex flex-col">
    <el-row>
      <el-input
        v-model="query.keyword"
        size="small"
        class="w-200px"
        :placeholder="$t('codeOrName')"
        @keyup.enter.native="searchList"
        clearable
      />
      <el-button class="ml-10px" size="small" type="primary" @click="searchList">{{
        $t('search')
      }}</el-button>
      <el-button
        class="r"
        :disabled="multiple"
        size="small"
        type="primary"
        @click="add"
        v-if="!single"
        >{{ $t('addTo') }}</el-button
      >
    </el-row>
    <el-row class="flex-1 mt-20px h-320px">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column
          v-for="(item, key, index) in tableHeader"
          :prop="item"
          show-overflow-tooltip
          :key="index"
          :label="key"
        ></el-table-column>
        <el-table-column prop="status" :label="$t('operate')" width="150" v-if="single">
          <template v-slot="scope">
            <el-button size="mini" @click="singleAdd(scope.row)">{{ $t('confirm') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        class="mt-20px"
        background
        @size-change="searchList()"
        @current-change="getList()"
        :current-page.sync="query.pageNum"
        :page-sizes="$pageSizeAll"
        :page-size.sync="query.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import documentManagementService from '@/services/documentManagement'

export default {
  name: 'refrenceAttributeSearch',
  props: ['single', 'standardId', 'detail', 'referenceInfo', 'classId'],
  data() {
    return {
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 15,
        keyword: '',
      },
      dataList: [],
      selection: [],
      multiple: true,
      loading: false,
      tableHeader: {},
    }
  },
  created() {
    this.searchList()
  },
  watch: {
    referenceInfo: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.tableHeader = {}
          this.tableHeader[newVal.displayReferenceAttributeName] =
            newVal.displayReferenceAttributeCode
          this.tableHeader[newVal.referenceAttributeName] = newVal.referenceAttributeCode
        }
      },
    },
  },
  methods: {
    searchList() {
      this.query.pageNum = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      const params = {
        DataId: this.detail.dataId,
        AttributeId: this.detail.attributeId,
        ClassId: this.detail.classId || this.classId,
        StandardId: this.standardId,
        Filter: this.query.keyword, // 模糊查找
        SkipCount: (this.query.pageNum - 1) * this.query.pageSize,
        MaxResultCount: this.query.pageSize,
      }
      const res = await documentManagementService.getReferenceColumnData(params)
      if (res && res.code === 0 && res.data) {
        this.dataList = res.data
        this.total = res.totalCount
      }
      this.loading = false
    },
    // 单个
    singleAdd(row) {
      this.$emit('selectReferenceClassAttributeId', row)
    },
    // 多个
    add() {
      this.$emit('selectReferenceClassAttributeId', this.selection)
    },
    selectionChange(val) {
      this.selection = val
      this.multiple = !val.length
    },
  },
}
</script>
<style lang="scss" scoped>

.detail {
  height: 500px;
  /deep/.el-table__body-wrapper {
    height: 90% !important;
  }
}

</style>
